export default __webpack_public_path__ + "static/media/button-login-hover.60e1cd2c.svg";